// style.js
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 88,
    padding: 20,
    display: 'flex',
    gap: 12,
    boxSizing: 'border-box',
    borderRadius: 4,
    border: '1px solid #D5D6DD',
    overflow: 'hidden',
  },
  image: {
    position: 'relative',
    top: -11,
    width: 77,
    height: 77,
  },
  imageSupplementary: {
    width: 52,
    height: 53,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    boxSizing: 'border-box',
  },
  title: {
    fontSize: 16,
    fontWeight: 400,
    color: '#424242',
    fontStyle: 'normal',
    lineHeight: '32px',
  },
  description: {
    fontSize: 14,
    fontWeight: 400,
    color: '#616161',
    fontStyle: 'normal',
    lineHeight: '32px',
  },
}));

export default useStyles;
